import { OutputEmailAccountsService } from 'src/app/domain/export-configuration/activation-email-templates/output-email-accounts.service';
import { ClientService } from 'src/app/base/services/client/client.service';
import { RoleService } from 'src/app/base/services/role.service';
import { ImportConfigurationEditFormsCoordinatorService } from './../import-configuration-edit-forms-coordinator.service';
import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EditService, FilterService, GridModule, PageService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { ExportInterfaceConfigTemplateDTO, ExportInterfaceConfigurationDTO, ExportInterfaceConfigurationDetailsDTO, ExportInterfaceConfigurationFileProcessType, ExportInterfaceConfigurationTransferType, ExportInterfaceConfigurationType, UpdateExportInterfaceConfigurationDTO } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ConfigurationsService } from 'src/app/domain/export-configuration/configurations/configurations.service';
import { ConfigurationFormCoordinatorService } from 'src/app/domain/export-configuration/shared/configuration-forms/configuration-form-coordinator.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { ConfigurationFormsOverviewComponent } from "../../../../export-configuration/shared/configuration-forms/configuration-forms-overview/configuration-forms-overview.component";
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { FormGroup } from '@angular/forms';
import { ConfigurationTemplatesOverviewComponent } from 'src/app/domain/export-configuration/shared/configuration-templates-overview/configuration-templates-overview.component';
import { AuthService } from 'src/app/base/services/auth.service';
import { ConfigurationTemplatesService } from 'src/app/domain/export-configuration/configuration-templates/configuration-templates.service';
import { Router } from '@angular/router';
import { importConfigurationConfigurationRoute } from 'src/app/core/routing/route-names';
import * as pages from '../../../../../core/routing/page-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import { lastValueFrom, merge, tap } from 'rxjs';
import { ExportConfigurationMasterDataServiceService } from 'src/app/domain/export-configuration/export-configuration-master-data.service';
import { ActivationEmailTemplatesOverviewService } from 'src/app/domain/export-configuration/shared/activation-email-templates-overview/activation-email-templates-overview.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-configuration-form-response',
    templateUrl: './configuration-form-response.component.html',
    styleUrl: './configuration-form-response.component.scss',
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
        ConfigurationFormsOverviewComponent,
        ToolbarModule,
        DialogModule,
        ConfigurationTemplatesOverviewComponent
    ],
    providers: [PageService, FilterService, ToolbarService, SortService, EditService]
})
export class ConfigurationFormResponseComponent extends GridBaseComponent<any> implements OnInit {

  @ViewChild('loadTemplateDialog')
  public loadTemplateDialog: DialogComponent;

  @ViewChild('configTemplateOverview')
  public configTemplateOverview: ConfigurationTemplatesOverviewComponent;

  public selectedExportTemplate: ExportInterfaceConfigTemplateDTO;
  public selectedExportConfig: ExportInterfaceConfigurationDTO;

  private servicesLoaded = false;
  private editAwaitingServices = false;

  private isDataValid = true;
  private addedRecordId: number = null;

  public get isCreate(): boolean {
    return this.importConfigurationEditFormsCoordinatorService.configuration?.id === 0;
  }

  public get exportConfiguration(): ExportInterfaceConfigurationDTO {
    return this.exportConfigurationFormCoordinatorService.configurationDetailsDTO;
  }

  constructor(
    translateService: TranslateService,
    public authService: AuthService,
    protected configurationsService: ConfigurationsService,
    private exportConfigurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private importConfigurationEditFormsCoordinatorService: ImportConfigurationEditFormsCoordinatorService,
    private spinnerService: SpinnerService,
    private configurationTemplateService: ConfigurationTemplatesService,
    private router: Router,
    private roleService: RoleService,
    private clientService: ClientService,
    private outputEmailAccountsService: OutputEmailAccountsService,
    private activationEmailTemplatesOverviewService: ActivationEmailTemplatesOverviewService,
    private exportConfigurationMasterDataServiceService: ExportConfigurationMasterDataServiceService,
    private toastService: ToastService
  ) {
    super(translateService, configurationsService);
  }

  ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.configurationsService, this.spinnerService),
    });

    this.configurationsService.importConfigurationId = null;
    this.exportConfigurationFormCoordinatorService.configurationDetailsDTO = null;
    this.exportConfigurationFormCoordinatorService.resetForms();
    this.exportConfigurationFormCoordinatorService.isTemplateMode = false;

    this.editDialogTitle = 'i18n.domain.import-configuration.edit.response.edit-configuration-dialog-title';

    //Workaround to resolve services from routing
    lastValueFrom(merge(this.clientService.getAccessibleClients(),
          this.roleService.getRoleMappingInfo(),
          this.outputEmailAccountsService.loadOutputEmailAccounts(),
          this.activationEmailTemplatesOverviewService.loadInitialData(),
          this.exportConfigurationMasterDataServiceService.loadSourceFields())).then(() => {
            this.servicesLoaded = true;
            if (this.editAwaitingServices) {
              this.grid.editModule.startEdit();
              this.editAwaitingServices = false;
            }
          });

    this.importConfigurationEditFormsCoordinatorService.configurationUpdated.subscribe(() => {
      this.setExportConfigurationServiceProperties();
      this.grid?.refresh();
    });

    this.setExportConfigurationServiceProperties();
  }

  public override actionBegin(args) {
    if (((args as any).requestType === 'beginEdit' || (args as any).requestType === 'add')) {
      if (!this.servicesLoaded) {
        this.editAwaitingServices = true;
        args.cancel = true;
        return;
      }
    }
    super.actionBegin(args);
  }

  public override actionComplete(args) {
    super.actionComplete(args);
    if (((args as any).requestType === 'beginEdit' || (args as any).requestType === 'add')) {
      const dialog = (args as any).dialog;
      dialog.width = '1000';
      dialog.buttons = [
        {
          buttonModel: { content: this.translateService.instant('i18n.shared.cancel'), cssClass: 'e-control e-btn e-lib e-flat' },
          click: () => {
            this.grid.editModule.closeEdit();
          }
        },
        {
          buttonModel: { content: '<span class="e-icons icon-cloud--download me-2"></span>' + this.translateService.instant('i18n.domain.export-configuration.shared.buttons.load-from-template'), cssClass: 'e-control e-btn e-lib btn-outline-secondary e-flat' },
          click: () => {
            this.loadFromTemplate();
          }
        },
        {
          buttonModel: { content: this.translateService.instant('i18n.shared.save'), cssClass: 'e-control e-btn e-lib e-primary e-flat' },
          click: () => {
            this.saveConfiguration();
          }
        }
      ];
    }
    if((args as any).requestType === 'cancel'){
      this.selectedExportConfig = null;
      this.handleRoute();
      this.grid.refresh();
    }
  }

  public override onAdd(): void {
    this.configurationsService.addRecord().subscribe((data) => {
      this.addedRecordId = data.id;
      this.grid.refresh();
    });
  }

  public dataBound(): void{
    if(this.addedRecordId){
      //Needed to prevent side effects from grid refresh
      setTimeout(() => {
        this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(this.addedRecordId));
        this.grid.startEdit();
        this.addedRecordId = null;
      }, 0);

    } else {
      var id = UrlHelper.getIdForSegment(pages.importConfigurationsResponsePageName, this.router);
      if (id != null && id != undefined && this.grid.getRowIndexByPrimaryKey(id) >= 0){
        this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(id));
        this.grid.startEdit();
      }
    }
  }

  public templateDialogCancelClicked() {
    this.selectedExportTemplate = null;
    this.loadTemplateDialog.hide();
  }

  public templateDialogOnOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  public templateSelectedAndClose(selectedConfigurationTemplate: ExportInterfaceConfigTemplateDTO) {
    this.selectedExportTemplate = selectedConfigurationTemplate;
    this.templateDialogOkClicked();
  }

  public templateSelected(selectedConfigurationTemplate: ExportInterfaceConfigTemplateDTO) {
    this.selectedExportTemplate = selectedConfigurationTemplate;
  }

  public templateDialogOkClicked() {
    if (this.selectedExportTemplate) {
      this.configurationTemplateService.getConfigurationDetails(this.selectedExportTemplate.id).subscribe((configurationDetailsDto: ExportInterfaceConfigurationDetailsDTO) => {
        this.exportConfigurationFormCoordinatorService.loadFromTemplate(configurationDetailsDto);
      });

    }
    this.selectedExportTemplate = null;
    this.loadTemplateDialog.hide();
  }

  public loadFromTemplate() {
    this.loadTemplateDialog.show();
    this.configTemplateOverview.refresh();
  }

  public getTypeName(type: number): string {
    return 'i18n.shared.configurationTypes.' + ExportInterfaceConfigurationType[type];
  }

  public getTransferTypeName(transferType: number): string {
    return 'i18n.shared.transferTypes.' + ExportInterfaceConfigurationTransferType[transferType];
  }

  protected override async initializeEditForm(data: any): Promise<void> {
    this.selectedExportConfig = data as ExportInterfaceConfigurationDTO;
    this.handleRoute();
    this.exportConfigurationFormCoordinatorService.loadConfigurationDetails(this.selectedExportConfig.id);
    this.gridEditForm = new FormGroup({});
  }

  protected override getEditDialogTitleParams(rowData: any): object {
    return {};
  }

  private saveConfiguration(): void {
    this.validateWholeForm();
    if (this.exportConfigurationFormCoordinatorService.isWholeFormValid) {
      var formData = this.getUpdateDTOFromFormData();
      this.isDataValid = true;
      this.validateData(formData);
      if (this.isDataValid) {
        this.configurationsService.updateRecord(formData).pipe(
          tap(data => {
            this.grid.editModule.closeEdit();
            this.grid.refresh();
          }),
        ).subscribe();
      }
    } else {
      if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
        this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.form-invalid.title',
          'i18n.domain.export-configuration.configurations.messages.form-invalid.message', null);
      }
    }
  }

  private handleRoute(): void {
    //Create route here to add in importconfig id
    var importConfigurationId = this.importConfigurationEditFormsCoordinatorService.configuration.id;
    var route = importConfigurationConfigurationRoute + '/' + importConfigurationId + '/' + pages.importConfigurationsResponsePageName;
    if (!this.selectedExportConfig) {
      this.router.navigate([route]);
      return;
    }

    const id = this.selectedExportConfig.id;
    if (!id) {
      this.router.navigate([route + "/" + pages.exportConfigurationCreatePageName])
      return;
    }
    var exportConfigId = UrlHelper.getIdForSegment(pages.importConfigurationsResponsePageName, this.router);
    if (exportConfigId == this.selectedExportConfig.id) {
      //dont redirect, url is already correct
      return;
    }

    this.router.navigate([route + "/" + this.selectedExportConfig.id]);
  }

  private validateWholeForm() {
    let optionalFormsValid = false;
    this.exportConfigurationFormCoordinatorService.isWholeFormValid = false;
    let ignoreFileTabs = false;

    var configurationFormGeneral = this.exportConfigurationFormCoordinatorService.configurationFormGeneral;
    var configurationFormEmail = this.exportConfigurationFormCoordinatorService.configurationFormEmail;
    var configurationFormFTP = this.exportConfigurationFormCoordinatorService.configurationFormFTP;
    var configurationFormREST = this.exportConfigurationFormCoordinatorService.configurationFormREST;
    var configurationFormFileName = this.exportConfigurationFormCoordinatorService.configurationFormFileName;
    var configurationFormFileFilter = this.exportConfigurationFormCoordinatorService.configurationFormFileFilter;


    //Email
    if (configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.Email) {
      if (configurationFormEmail.valid) {
        optionalFormsValid = true;
      }
    }
    //SFTPServer
    if (configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.SFTPServer) {
      optionalFormsValid = true;
    }
    //FTPClient
    if (configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.FTPClient) {
      if (configurationFormFTP.valid) {
        optionalFormsValid = true;
      }
    }
    //REST
    if (configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.REST) {
      if (configurationFormREST.valid) {
        optionalFormsValid = true;
      }
    }
    //SFTPServerOnly
    if (configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.SFTPServerOnly) {
      optionalFormsValid = true;
      ignoreFileTabs = true;
    }

    if (configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.CustomerBacklog) {
      if (this.exportConfigurationFormCoordinatorService.configurationFormBacklog.valid) {
        optionalFormsValid = true;
      }
      else {
        optionalFormsValid = false;
      }
    }

    if (configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.Finance) {
      if (this.exportConfigurationFormCoordinatorService.configurationFormFinance.valid) {
        optionalFormsValid = true;
      }
      else {
        optionalFormsValid = false;
      }
    }

    if (configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.EDIOrder
      || configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.XMLOrder
      || configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.CustomerConnection
      || configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.AS2
      || configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.ProductCatalog) {
      optionalFormsValid = true;
      ignoreFileTabs = true;
    }

    if (configurationFormGeneral.valid
      && (ignoreFileTabs || configurationFormFileName.valid && configurationFormFileFilter.valid &&
        (configurationFormFileName.get('processType').value === ExportInterfaceConfigurationFileProcessType.ColumnBased && this.exportConfigurationFormCoordinatorService.configurationFormFileFields.valid) ||
        configurationFormFileName.get('processType').value === ExportInterfaceConfigurationFileProcessType.LineBased && this.exportConfigurationFormCoordinatorService.configurationFormFileLineBasedAllAttributes.valid)
      && optionalFormsValid) {
      this.exportConfigurationFormCoordinatorService.isWholeFormValid = true;
    }
  }

  private validateData(data: UpdateExportInterfaceConfigurationDTO) {
    if ((data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.Email
      || data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.SFTPServer
      || data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.SFTPServerOnly)
      && data.configurationDetails.active == true
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.EDIOrder
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.XMLOrder
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.CustomerConnection
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.ProductCatalog) {
      let atleastOneUserHasAccess = false;
      if (data.configurationDetails.userAccessList) {
        atleastOneUserHasAccess = data.configurationDetails.userAccessList.some((ua) => ua.hasAccess);
      }
      if (!atleastOneUserHasAccess) {
        this.isDataValid = false;
        this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.data-invalid.title',
          'i18n.domain.export-configuration.configurations.messages.data-invalid.no-user-access', null);
      }
    }
  }

  private getUpdateDTOFromFormData(): UpdateExportInterfaceConfigurationDTO {
    return new UpdateExportInterfaceConfigurationDTO({
      configurationDetails: this.exportConfigurationFormCoordinatorService.createConfigurationDetailsDTOFromForm(),
    });
  }

  private setExportConfigurationServiceProperties(): void {
    if (this.isCreate) {
      this.configurationsService.importConfigurationId = null;
      this.configurationsService.selectedClient = null;
    } else {
      this.configurationsService.importConfigurationId = this.importConfigurationEditFormsCoordinatorService.configuration?.id;
      this.configurationsService.selectedClient = this.importConfigurationEditFormsCoordinatorService.configuration?.client;
    }
  }

}
